lmApp
  .service('GreetingsService', ['$q', 'ApiService', function ($q, ApiService) {

    var service = {};

    service.Confirm = function (code) {
      var deferred = $q.defer();

      var data = {
        ack: code
      };

      ApiService.Request('1/register/acknowledge', 'POST', data)
        .then(function (response) {
          deferred.resolve(response);
        }, function (reason) {
          reason.url = 'supervisor/1/register/acknowledge';
          reason.data = data;
          deferred.reject(reason);
        });

      return deferred.promise;
    };

    return service;
  }]);
